module.exports = __webpack_public_path__ + "media/images/countryrect/cg-8e507cb4d09633795c2d5f2fb59b42ea.svg";